export default __webpack_public_path__ + "static/media/banner_course_3.5855e56f.png";